<template>
  <div>
    <l-editor :disabled="disabled" :printMode="printMode" :isUploadImg="!isPreview" :height="data.height" v-if="data.type == 'texteditor'" v-model="value2" :placeholder="$t(data.placeholder)"   >
    </l-editor>
    <template v-else>
        <pre style="text-indent: 0;color: #10141a;font-size: 14px;margin: 0;white-space: pre-wrap;" v-if="disabled && printMode && ['input', 'textarea', 'password', 'number'].includes(data.type)">{{value2}}</pre>
        <l-barcode v-model="formData[data.valueKey]" v-bind="data" v-else-if="['barcode', 'qrcode'].includes(data.type) && data.bindingType == 1"/>
        <l-count
            v-else-if="['count'].includes(data.type)" 
            v-model="value2"
            :formatJson="data.formatJson"
            :formData="allFormData"
            :decimal="data.decimal"
            :thousandSeparator="data.thousandSeparator"
            :isChinese="data.isChinese">
        </l-count>
        <component v-else :is="getComponent(data.type)"
               v-model="value2"
               v-bind="data"
               :processId="formViewer && formViewer.processId"
               :nodeId="formViewer && formViewer.auditRelation[data.prop]"
               :placeholder="$t(data.placeholder)"
               :options="diyOptions || myOptions"
               :unit.sync="unitVal"
               :userId="data.type == 'title' && data.relationId ? formData[data.relationId] : ''"
               :size="data.subfield ? 'mini':data.size"
               :activeValue="toValueType(data.valueType,data.activeValue)"
               :inactiveValue="toValueType(data.valueType,data.inactiveValue)"
               :printMode="printMode"
               :disabled="disabled"
               :isRead="disabled"
               :isNotUpLoad="isPreview"
               :setPropVal="formViewer && formViewer.setValue"
                @change="handleChange($event,data)"
                @unitChange="unitChange"
                :remoteMethod="remoteMethod"
                :loading="loading"    
                :remote="data.dataType =='4' ? true : false"
               >
            <span v-if="data.html" :style="data.type == 'divider' ? { 'font-size': data.fontSize + 'px','color': data.color} : {}"
                v-html="data.html"></span>
            <template v-if="['input'].includes(data.type) && data.prepend" #prepend >
                {{data.prepend}}
            </template>
            <template v-if="['input'].includes(data.type) && data.append" #append >
                {{data.append}}
            </template>
        </component>
    </template>
    
  </div>
</template>
<script>
import mixin from '../../mixin'
import {cloneDeep} from 'lodash';

export default {
    name: 'form-item',
    mixins: [mixin()],
    inject: ["formViewer"],
    props: {
        value:{},
        data: {
            type: Object,
            default: () => {
                return {}
            }
        },
        formData:{
            type: Object,
            default: () => {
                return {}
            }
        },
        allFormData: {
            type: Object,
            default: () => {
                return {};
            },
        },
        isForm:{// 是否表单里的对象，用来区分对查询框的操作
            type:Boolean,
            default:false
        },
        upCtrls:{
            type:Object,
            default:()=>{
                return {}
            }
        },
        isRead:{// 是否表单里的对象，用来区分对查询框的操作
            type:Boolean,
            default:false
        },
        isPreview:{
            type:Boolean,
            default:false
        },
        printMode:{
            type:Boolean,
            default:false
        },
    },
    data(){
        return {
            loading:false
        }
    },
    computed:{
        value2:{
            get(){
                return this.value
            },
            set(val){
                this.$emit('input', val)
            }
        },
        unitVal:{
            get(){
                if (!this.data.unitCode) return this.data.unit
                console.log(this.formData[this.data.unitCode], 'this.formData[this.data.unitCode]===')
                console.log(this.formData, 'this.formData===')
                if (!this.formData[this.data.unitCode] && this.data.unit) {
                    this.$set(this.formData, this.data.unitCode, this.data.unit)
                }
                return this.formData[this.data.unitCode]
            },
            set(val){
                if (this.data.unitCode) this.$set(this.formData, this.data.unitCode, val)
            }
        },
        disabled(){
            if(this.isRead){
                return true
            }

            if(this.data.subfield){
                const abledList = this.formData.abledList || []
                if(this.formData.disabled && abledList.indexOf(this.data.prop) == -1 ){
                    return true
                }
            }
            return this.data.disabled
        }
    },
    mounted(){
        if(this.data.assemblyID){
            var arr = this.data.assemblyID.split(',')
            var getAssemblyObj = {
                getAssemblyData:arr,
                id:this.data.prop
            }
            this.$emit('getAssemblyData',getAssemblyObj)
        }
    },
    methods: {
        setAssemblyData(val){
            console.log(val,'那到职');
            var arr = []
            val.setAssemblyData.forEach(item => {
                arr.push(JSON.parse(item))
            })
            console.log(arr);
            const mergedObject = arr.reduce((accumulator, current) => {
                return { ...accumulator, ...current };
            }, {});
            console.log(mergedObject,'mergedObject');
            console.log(JSON.stringify(mergedObject));
            this.setQueryData(JSON.stringify(mergedObject))
        },
        remoteMethod(query){
            console.log(query,'query-----');
            if(query){
                console.log(this.data);
                var key = this.data.remoteParams
                var obj = {}
                obj[key] = query
                console.log(obj,'obj------');
                var jsonObj = JSON.stringify(obj)
                this.setQueryData(jsonObj)
            }
            console.log(this.data);
        },
        changeQueryData(val){
            console.log(val,'val-----');
            console.log('jinlai');
            if(val){
                var jsonObj = JSON.stringify(val)
                this.setQueryData(jsonObj)
            }
        },
        async setQueryData(val){
            var jsonData = cloneDeep(JSON.parse(this.data.params))
            var jsonQuery = JSON.parse(val)
            const mergedObj1 = Object.assign({}, jsonData, jsonQuery)
            this.$set(this.data, 'params', cloneDeep(JSON.stringify(mergedObj1)))
            this.$set(this.data, 'timmer', new Date().getTime())
            // this.data.params = cloneDeep(JSON.stringify(mergedObj1))
            console.log(this.data,'data------jinlai');
            await this.lr_loadDataByURL(this.data.httpUrl,this.data.httpWay,this.data.params)
            var arr = []
            var dataSource = this.lr_dataURLSource[`${this.data.httpUrl}_${this.data.params}`] || []
            dataSource.forEach(item => {
                arr.push({
                    label:item[this.data.dataLabelKey],
                    value:item[this.data.dataValueKey]
                })
            })
            this.diyOptions = arr
            console.log(this.diyOptions,'this.diyOptions------');
        },
        toValueType(type,value){
            if(!this.$validatenull(value) && !this.$validatenull(type)){
                switch(type){
                    case 'boolean':
                        return value == 'true';
                    case 'string':
                        return value;
                    case 'number':
                        return Number(value);
                }
            }
        },
        unitChange (val) {
            if (this.data.unitCode) this.$set(this.formData, this.data.unitCode, val)
            console.log(this.data.unitCode, 'this.data.unitCode---')
            console.log(this.formData[this.data.unitCode], 'this.formData[this.data.unitCode]---')
        },
        handleChange(changeData,list){
            console.log(changeData, 'changeData---');
            console.log(list, 'changeData---');
            this.$nextTick(()=>{
                if(list.scenario){
                    this.$emit('changeEvent',{
                        component: list,
                        changeEvent: list.scenario,
                        value:changeData,
                    })
                }
                // 1.改变级联数据，清空级联数据
                if(["checkbox","radio","select","selectMultiple","treeselect","layerselect",'companySelect','departmentSelect','userSelect'].includes(this.data.type)){
                    this.clearSubValue(this.data.prop)
                }
                // 根据右侧赋值字段给表单赋值地图信息
                if (this.data.type == "layerbmap") {
                    if (this.data.bindaddr) {
                        if(changeData){
                            this.$set(this.formData, this.data.bindaddr, changeData.address); //设置绑定地址
                        }
                        else{
                            this.$set(this.formData, this.data.bindaddr, ''); //设置绑定地址
                        }
                    }
                    if (this.data.bindaddrpoint) {
                        if(changeData){
                            this.$set(this.formData,this.data.bindaddrpoint,`${changeData.lng},${changeData.lat}`);//设置绑定经纬度
                        }
                        else{
                            this.$set(this.formData, this.data.bindaddrpoint, ''); //设置绑定地址
                        }
                    }
                }
                // 弹窗赋值   notChangeForm 不影响主表单
                if(this.data.type == 'layerselect' && !this.data.notChangeForm){
                    this.data.columns.forEach(col=>{
                        if(col.valueKey){
                            if(changeData){
                                this.$set(this.formData,col.valueKey,changeData[col.prop])
                            }
                            else{
                                this.$set(this.formData,col.valueKey,undefined)
                            }
                        }
                    })
                }
                this.$emit('change',{prop:this.data.prop,obj:changeData})
            })
        },
        clearSubValue(upProp) {
            if(this.upCtrls[upProp]){
                this.upCtrls[upProp].forEach((prop)=>{
                    this.$set(this.formData,prop,'')
                    this.clearSubValue(prop)
                })
            }
        }
    }
}
</script>